<template>
	<div class="kefu_v">
		<iframe :src="kefu_link"></iframe>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch'

	export default {
		name: "index",
		components: {},
		data() {
			return {
				kefu_link: ''
			};
		},
		created() {
			this.$parent.footer('user');
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
 window.location.href = 'https://t.me/wst201';
 
 return;
var u = '//kft.ag-lotre.com/index/index/home?visiter_id=&visiter_name=&avatar=&business_id=1&groupid=1&special=1';
				Fetch('/user/info').then((r) => {
					this.data = r.data;
					console.log(r.data);
					this.kefu_link = u+'&visiter_name='+r.data.mobile+'&visiter_id='+r.data.uid+'&avatar='+r.data.user_icon
				});
				/*Fetch('/index/webconfig', {type: 'web'}).then(res => {
				    this.data = res.data;
				})*/
			},
		}
	};
</script>

<style lang="less" scoped>
	.kefu_v {
		position: fixed;
		width: 100%;
		height: 100%;
		-webkit-overflow-scrolling: touch;
		overflow-y: scroll;

		iframe {
			padding-bottom: 55px;
			width: 100%;
			height: 100%;
		}
	}
</style>
